import { render, staticRenderFns } from "./CompanyContainer.vue?vue&type=template&id=6e20cc54&scoped=true&"
import script from "./CompanyContainer.vue?vue&type=script&lang=js&"
export * from "./CompanyContainer.vue?vue&type=script&lang=js&"
import style0 from "./CompanyContainer.vue?vue&type=style&index=0&id=6e20cc54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20cc54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabs})
